<template>

  <div class="wizard">

    <header class="wizard-nav px-4">
      <h5>
        <ArrowLeftIcon v-if="step > 3" @click="returnStep()"
                       size="1x" style="cursor: pointer"/> <b>{{ title }}</b> ({{ step }}/7)
      </h5>
      <a @click="logout" id="cancel">Cancelar <x-icon></x-icon></a>
    </header>

    <div class="wizard-progressbar" :style="{ width: `${(100 * step) / 7}%`}">

    </div>

    <div class="wizard-container pt-5">

      <div id="step1" v-if="step === 1">

        <Register @createUser="saveStep1"/>

      </div>

      <div id="step2" v-else-if="step === 2">
        <div class="col-md-6 text-center mx-auto">
          <h3>Precisamos de um nome para a sua conta</h3>
          <p>Qual nome você deseja dar para sua conta?</p>
        </div>

        <div class="col-md-3 mx-auto pt-5">
          <div class="row">
            <div class="form-group col-md-12 pb-2">
              <label for="name_account">Nome</label>
              <input v-model="nameAccount" :class="errorsNameAccount" class="form-control input" id="name_account" aria-describedby="emailHelp">
            </div>
          </div>
          <button :disabled="finishStep2" @click="saveStep2" class="btn btn-primary btn-block">Próximo Passo</button>
        </div>

      </div>

      <div id="step3" v-else-if="getAccount && step === 3">
        <div class="col-md-6 text-center mx-auto">
          <h3>Precisamos saber de alguns dados</h3>
          <p>Por favor, informe os dados abaixo</p>
        </div>

        <div class="col-md-4 mx-auto pt-5">

          <div class="row">
            <div class="form-group col-md-12">
              <label for="responsible-name">Nome do Responsável</label>
              <input v-model="getAccount.responsibleName" type="text" class="form-control input" id="responsible-name" aria-describedby="emailHelp">
            </div>
            <div class="form-group col-md-12">
              <label for="phone">Telefone</label>
              <input v-model="getAccount.phone" type="phone" class="form-control input" id="phone" v-mask="'(##) #### #####'">
            </div>
            <div class="form-group col-md-12">
              <label for="address">Endereço</label>
              <input v-model="getAccount.address" type="text" class="form-control input" id="address">
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-8">
              <label for="city">Cidade</label>
              <CitySelect v-model="getAccount.cityCode" :code-uf="getAccount.uf" type="text" class="custom-select input" id="city"/>
            </div>
            <div class="form-group col-md-4 pb-2">
              <label for="account-uf">UF</label>
              <StatesSelect v-model="getAccount.uf" class="custom-select input" id="account-uf"/>
            </div>
          </div>
          <button :disabled="finishStep3" @click="updateAccountAndNextStep()" class="btn btn-primary btn-block">Próximo Passo</button>
        </div>

      </div>

      <div id="step4" v-else-if="step === 4">
        <div class="col-md-6 text-center mx-auto">
          <h3>Queremos saber mais sobre sua área</h3>
          <p>Em qual área você atua?</p>
        </div>

        <div class="col-md-8 mx-auto pt-5">
          <div class="row">

            <div class="col-md-4">
              <div class="card" @click="getAccount.businessArea = 'company'"
                   :class="{'selected-card': getAccount.businessArea === 'company' }">
                <div class="card-body">
                  <home-icon size="3x" style="color: black;"/>
                  <p class="text-1 mt-3">Empresa</p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card" @click="getAccount.businessArea = 'office'"
                   :class="{'selected-card': getAccount.businessArea === 'office' }">
                <div class="card-body">
                  <briefcase-icon size="3x" style="color: black;"/>
                  <p class="text-1 mt-3 text-wrap">Escritório de Contabilidade</p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card" @click="getAccount.businessArea = 'others'"
                   :class="{'selected-card': getAccount.businessArea === 'others' }">
                <div class="card-body">
                  <user-icon size="3x" style="color: black;"/>
                  <p class="text-1 mt-3">Outros</p>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-5 mx-auto pt-5">
              <button :disabled="finishStep4" @click="updateAccountAndNextStep" class="btn btn-primary btn-block">Próximo Passo</button>
            </div>
          </div>

        </div>
      </div>

      <div id="step5" v-else-if="step === 5">
        <Companies :account="getAccount" @nextStep="updateAccountAndNextStep"/>
      </div>

      <div id="step6" v-else-if="step === 6">
       <Apps :account="getAccount" @nextStep="updateAccountAndNextStep"/>
      </div>

      <div id="step7" v-else-if="step === 7">
        <UploadCertificates @nextStep="updateAccountAndNextStep"/>
      </div>

    </div>

  </div>

</template>

<script>
  import StatesSelect from './shares/specialTag/StatesSelect'
  import CitySelect from '@/components/shares/specialTag/CitySelect'
  import Loading from './shares/Loading';
  import { XIcon, BriefcaseIcon, HomeIcon, UserIcon, ArrowLeftIcon } from 'vue-feather-icons'
  import { mask } from 'vue-the-mask'
  import Companies from '@/components/wizard/Companies'
  import GetAccount from '@/mixins/GetAccount'
  import GetUser from '@/mixins/GetUser'
  import Apps from '@/components/wizard/Apps'
  import UploadCertificates from '@/components/wizard/UploadCertificates'
  import Register from '@/components/wizard/Register'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import GetPartner from '@/mixins/GetPartner'

  const components = {
    Apps,
    ArrowLeftIcon,
    BriefcaseIcon,
    CitySelect,
    Companies,
    HomeIcon,
    Loading,
    Register, StatesSelect, UploadCertificates, UserIcon, XIcon
  }

  export default {
    components: components,
    computed: {
      finishStep2() {
        return !this.nameAccount
      },
      finishStep3() {
        let sizeNumberPhone = this.getAccount.phone && this.getAccount.phone.match(/\d/g)

        return  !this.getAccount.responsibleName ||
          !(sizeNumberPhone && sizeNumberPhone.length >= 10) ||
          !this.getAccount.address ||
          !this.getAccount.cityCode ||
          !this.getAccount.uf
      },
      finishStep4() {
        return !this.getAccount.businessArea
      },
      title(){
        if (this.step === 1){
            return 'E-mail e senha '
        } else if (this.step === 2){
            return 'Nome da conta '
        } else if (this.step === 3) {
            return 'Seus dados '
        } else if (this.step === 4) {
            return 'Área de atuação '
        } else if (this.step === 5) {
            return 'Cadastro de empresa(s) '
        } else if (this.step === 6) {
            return 'Apps '
        } else if (this.step === 7){
            return 'Certificado (opcional) '
        } else {
            return 0;
        }
      }
    },
    created() {
      if (!this.getUser) {
        this.step = 1
        return
      }

      if (this.getAccount && this.getAccount.step === 8) {
        this.$router.push('/')
        return
      }

      if (this.getUser && !this.getAccount)
        this.step = 2
      else if (this.getUser && !this.getAccount.step)
        this.step = 3
      else if (this.getUser && this.getAccount.step)
        this.step = parseInt(this.getAccount.step)

    },
    data() {
      return {
        addressAccount: '',
        // step 4 - update account
        businessArea: '',
        cityAccount: '',
        errorsNameAccount: [],
        // data step 2 - create account
        nameAccount: '',
        phoneAccount: '',
        // data step 3 - update account
        responsibleNameAccount: '',
        stateAccount: 'SP',
        step: 0,
      }
    },
    directives: { mask },
    methods: {
      async loadUser() {
        const response = await this.axios.get('auth/validate_token')
        this.setUser(response.data)
      },
      logout() {

        if (confirm('Tem certeza?')){
          if (this.getUser) {
            this.setUser(null)
            this.axios.delete('/auth/sign_out')
              .then(() => this.setUser(null))
              .then(() => this.$ls.remove('last_account_id', { withoutKey: true }))
              .catch((e) => this.$notify.addError(e))
          }
          this.$router.push('/login')
        }

      },
      returnStep() {
        this.openGlobalLoad()
        setTimeout(() => {
          this.step--
          this.closeGlobalLoad()
        }, 500)
      },
      saveStep1(user) {
        this.setUser(this.$parse.toCamelcase(user))
        this.step = 2
      },
      saveStep2() {
        const data = { name: this.nameAccount, step: 3 }
        if (this.getPartner)
          data['account_id'] = this.getPartner.id

        this.openGlobalLoad()
        this.axios.post('accounts', data)
          .then(resp => this.setAccount(this.$parse.toCamelcase(resp.data)))
          .then(() => this.step = 3)
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())

      },
      setAccountInStep3() {
        if (!this.getAccount.responsibleName)
          this.getAccount.responsibleName = this.getUser.name
        if (!this.getAccount.uf){
          this.getAccount.uf = 'SP'
          this.getAccount.cityCode = '3550308'
        }
      },
      updateAccountAndNextStep() {
        const account = this.$parse.toSnakecase(this.getAccount)
        account.step = this.step + 1

        this.openGlobalLoad()
        this.axios.put(`/accounts/${this.getAccount.id}`, account)
          .then(resp => this.setAccount(resp.data))
          .then(() => this.step++)
          .then(() => {
            if (this.step === 8)
              this.loadUser()
              this.$router.push('/')
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      }
    },
    mixins: [GetUser, GetAccount, GetPartner, GlobalLoading],
    name: 'Wizard',
    watch: {
      step(value) {
        if (value === 3)
          this.setAccountInStep3()
      }
    },
  }
</script>

<style scoped>
  .error {
    border-color: red;
  }

  .wizard-nav {
    grid-area: grid-wizard-nav;
    height: 88px;
    background: #FFFFFF;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 8px 0 rgba(0, 0, 0, 0.09);
  }

  .wizard-progressbar {
    background: #15CE9A;
    height: 100%;
    z-index: 999;
  }

  .wizard-container {
    grid-area: grid-wizard-container;
    overflow: auto;
    margin: 0;
  }

  .wizard {
    display: grid;
    height: 100vh;
    grid-template-columns: 100%;
    grid-template-rows: 88px 8px 1fr;
    grid-template-areas:
      'grid-wizard-nav'
      'wizard-progressbar'
      'grid-wizard-container';
  }

  .card{
    text-align: center;
    cursor: pointer;
  }

  .selected-card {
    border: 1px solid #318BE3;
    border-radius: 5px;
    box-shadow: 0 4px 20px rgba(92, 92, 92, 0.25);
  }

  #cancel:hover{
    cursor: pointer;
    color: #615f5f;
  }
  #cancel:active{
    color: #939090;
  }

  .text-1 {
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0;
    color: #051B30;
    margin: 0;
  }

</style>
